"use client";

import { motion } from "framer-motion";

export function LoadingDots() {
  return (
    <div className="flex items-center justify-center gap-2 py-4">
      {[0, 1, 2].map((index) => (
        <motion.span
          key={index}
          className="block h-2.5 w-2.5 rounded-full bg-foreground"
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 0.2, repeat: Infinity, delay: index * 0.12 }}
        />
      ))}
    </div>
  );
}
